module.exports = __webpack_public_path__ + "img/mikrotik.3beb18f.svg";